var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "literary_detail"
  }, [_c('dl', {
    staticClass: "literary_series_info"
  }, [_c('dt', {
    staticClass: "literary_series_title"
  }, [_vm._v(_vm._s(_vm.literarySeriesInfo.introductionTitle))]), _c('dd', {
    staticClass: "literary_series_summary"
  }, [_c('LineBreakElement', {
    staticClass: "literary_series_desc",
    attrs: {
      "tag-name": "div",
      "contents": _vm.literarySeriesInfo.introductionContents
    }
  }), _c('span', {
    staticClass: "literary_series_total"
  }, [_c('em', {
    staticClass: "blind"
  }, [_vm._v("연재 작품 수")]), _vm._v(_vm._s(_vm.literarySeriesInfo.countItem) + " 화 ")])], 1)]), _c('dl', {
    staticClass: "literary_author_info"
  }, [_c('dt', {
    staticClass: "literary_author_name"
  }, [_vm._v(_vm._s(_vm.literarySeriesInfo.authorName))]), _c('LineBreakElement', {
    staticClass: "literary_author_intro",
    attrs: {
      "tag-name": "dd",
      "contents": _vm.literarySeriesInfo.authorIntroduction
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }